import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, FormHelperText, Grid, Snackbar, Alert } from "@mui/material";
import OtpInput from "react-otp-input";
import * as Yup from "yup";
import { Formik } from "formik";
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE, BUTTON, VALIDATON_TEXT } from "../../shared/constants";
import AuthWrapper from "../../components/Authwrapper";

export default function OTP() {
  const navigate = useNavigate();
  const [snackData, setSnackData] = useState({
    show: false,
    message: "",
    type: "error",
  });
  const [timer, setTimer] = useState(120); // 2 minutes timer
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  // Function to handle the OTP submission
  const handleSubmitForm = (values,{ setSubmitting }) => {
    navigate("/passwordReset", { state: { showPage: true } });
    setSubmitting(false);
    // const payload = values;
    // AuthApiService.verifyOtp(payload)
    //   .then((response) => {
    //     if (response.statusCode === 200 && response.message !== "Invalid OTP") {
    //       setSnackData({
    //         show: true,
    //         message: API_SUCCESS_MESSAGE.OTP_VERIFY,
    //         type: "success",
    //       });

    //       // Perform further actions, like redirecting to the password reset page
    //       navigate("/passwordReset", { state: { showPage: true } });
    //     } else {
    //       setSubmitting(false);
    //       setSnackData({
    //         show: true,
    //         message: response?.message || API_ERROR_MESSAGE.INVALID_OTP,
    //         type: "error",
    //       });

    //     }
    //   })
    //   .catch((errResponse) => {
    //     setSubmitting(false);
    //     console.log("errResponse",errResponse)
    //     setSnackData({
    //       show: true,
    //       message: errResponse?.error?.message || API_ERROR_MESSAGE.VERIFY_OTP,
    //       type: "error",
    //     });

    //   });
  };

  // Function to handle OTP resend
  const handleResendOtp = () => {
    // let payload = {
    //   email: sessionStorage.getItem("email"),
    // };
    // AuthApiService.forgotPassword(payload)
    //   .then((response) => {
    //     setSnackData({
    //       show: true,
    //       message: response?.message || API_SUCCESS_MESSAGE.OTP_SENT,
    //       type: "success",
    //     });
    //     // Disable the resend button for 2 minutes
    //     setIsResendDisabled(true);

    //     // Start a new 2-minute timer
    //     setTimer(120);
    //   })
    //   .catch((errResponse) => {
    //     setSnackData({
    //       show: true,
    //       message:
    //         errResponse?.error?.message || API_ERROR_MESSAGE.INCORRECT_EMAIL,
    //       type: "error",
    //     });
    //   });
  };

  // Use Effect to update the timer every second
  useEffect(() => {
    let countdown;

    if (isResendDisabled && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      // Enable resend button after 2 minutes
      setIsResendDisabled(false);
      clearInterval(countdown);
    }

    // Cleanup interval on component unmount
    return () => clearInterval(countdown);
  }, [isResendDisabled, timer]);

  return (
    <>
    <AuthWrapper>
      <Formik
        initialValues={{
          email: sessionStorage.getItem("email"),
          otp: "", // Managed by Formik
        }}
        validationSchema={Yup.object().shape({
          otp: Yup.string()
            .length(6, VALIDATON_TEXT.OTP_COUNT)
            .required(VALIDATON_TEXT.OTP_REQUIRED)
            .matches(/^\d+$/, VALIDATON_TEXT.OTP_DIGIT),
        })}
        onSubmit={handleSubmitForm}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <OtpInput
                  value={values.otp} // Use Formik's value for OTP
                  onChange={handleChange("otp")} // Use Formik's handleChange
                  numInputs={4}
                  renderSeparator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                  inputStyle={{
                    width: "2.5rem",
                    height: "2.5rem",
                    margin: "0 10px",
                    fontSize: "1rem",
                    borderRadius: 4,
                    border: "1px solid rgba(0,0,0,0.3)",
                  }}
                />
                {touched.otp && errors.otp && (
                  <FormHelperText
                    error
                    id="standard-weight-helper-text-otp-login"
                  >
                    {errors.otp}
                  </FormHelperText>
                )}
              </Grid>

              {errors.submit && (
                <Grid item xs={12}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Grid>
              )}

              <Grid item xs={12}>
                  <Button
                    disableElevation
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    {BUTTON.VERIFY_OTP}
                  </Button>
              </Grid>

              <Grid item xs={12}>
                <Button
                  fullWidth
                  size="large"
                  variant="outlined"
                  color="secondary"
                  disabled={isResendDisabled} // Disable resend OTP button when timer is active
                  onClick={handleResendOtp}
                >
                  {isResendDisabled
                    ? `Resend One Time Pin in ${Math.floor(timer / 60)}:${String(timer % 60).padStart(2, "0")}`
                    : "Resend One Time Pin"}
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>

      <Snackbar
      style={{top:"80px"}}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackData.show}
        autoHideDuration={3000}
        onClose={() => setSnackData({ show: false })}
      >
        <Alert
          onClose={() => setSnackData({ show: false })}
          severity={snackData.type}
        >
          {snackData.message}
        </Alert>
      </Snackbar>
      </AuthWrapper>
    </>
  );
}

OTP.propTypes = {
  isDemo: PropTypes.bool,
};
